<template>
    <el-menu mode="horizontal" :ellipsis="false">
        <el-menu-item index="etusivu" @click="etusivuClick">Etusivu</el-menu-item>
        <el-menu-item index="ohje" @click="ohjeClick">Ohje</el-menu-item>
        <el-menu-item index="uutta" @click="releaseNotesVisible = true">Uutta Vahdissa</el-menu-item>
        <el-menu-item v-if="superUser" @click="yllapitoClick" index="yllapito">Ylläpito</el-menu-item>
        <div style="flex-grow: 1" />
        <el-menu-item index="profiili" data-test-id="headerProfiiliMenuItem">
            <ComAvatarButton />
        </el-menu-item>
        <el-menu-item index="kirjaudu" data-test-id="headerLogoutButton">
            <ComLogoutButton>
                <el-icon><SwitchButton /></el-icon>
            </ComLogoutButton>
        </el-menu-item>
    </el-menu>
    <ComReleaseNotesDialog v-model="releaseNotesVisible" />
</template>

<script setup lang="ts">
import { ref } from "vue"
import ComLogoutButton from "@/components/common/buttons/ComLogoutButton.vue"
import ComAvatarButton from "@/components/common/buttons/ComAvatarButton.vue"
import ComReleaseNotesDialog from "@/components/layout/header/ComReleaseNotesDialog.vue"
import { SwitchButton } from "@element-plus/icons-vue"
import router from "@/router"
import { useSuperUserOikeudet } from "@/methods/kayttajaOikeusComposables"

const { superUser } = useSuperUserOikeudet()

const releaseNotesVisible = ref(false)

const etusivuClick = () => {
    router.push({ name: "Etusivu" })
}

const ohjeClick = () => {
    window.open("https://scribehow.com/page/Vahti_ohje__wfWdtIrpRCyPAv802UyY0w", "_blank")
}

const yllapitoClick = () => {
    router.push({ name: "Yllapito" })
}

</script>
